export default "__VITE_ASSET__61231cf8__"